import * as React from 'react';

const styles = require('./VenueHighlights.scss');

export interface VenueHighlight {
    name: string;
    label: string;
    iconUrl: string;
}

export interface VenueHighlightsProps {
    highlights: VenueHighlight[];
}

export default class VenueHighlights extends React.Component<VenueHighlightsProps> {
    public render() {
        return (
            <div className={styles.className}>
                {this.props.highlights.map((higlight, idx) => {
                    return (
                        <div className={styles.highlight} key={idx} itemType='destination-weddings-highlights'>
                            <img className={styles.icon} src={higlight.iconUrl} />
                            <div className={styles.label}>{higlight.label}</div>
                        </div>
                    );
                })}
            </div>
        );
    }
}
